module.exports = __webpack_public_path__ + "static/img/reference pics_redmud chaiyi.645e9ed8.jpg";